import { memo } from 'react';
import useStore from 'store';
import { Box } from 'v1/ui';

const Underline = memo(function Underline(args: {
  top: number;
  left: number;
  width: number;
  height: number;
  active: boolean;
  messageId: string;
}) {
  const { top, left, width, height, active, messageId } = args;
  const handleUnderlineClick = useStore.useHandleUnderlineClick();

  const borderWidth = 2;
  const paddingX = 2;
  const paddingY = 1;

  const purple = 'rgba(142, 0, 254, 1)';
  const lightPurple = 'rgba(142, 0, 254, 0.1)';

  return (
    <Box
      onClick={() => handleUnderlineClick(messageId)}
      sx={{
        position: 'absolute',
        top: active ? `${top - paddingY}px` : `${top - paddingY + height}px`,
        left: `${left - paddingX}px`,
        width: `${width + paddingX * 2}px`,
        height: active
          ? `${height + borderWidth + paddingY}px`
          : `${borderWidth}px`,
        background: active ? lightPurple : undefined,
        borderBottom: `${borderWidth}px solid transparent`,
        borderColor: purple,
        zIndex: 2,
        transition: 'background-color 500ms ease-in-out',
        cursor: 'pointer',
      }}
    />
  );
});

export default Underline;
